import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  createFormLabel: {
    id: 'proforma-project-forms.CreateForm',
    defaultMessage: 'Create form',
    description: 'Label for a button for creating a new Jira form.'
  },
  description: {
    id: 'proforma-project-forms.Description',
    defaultMessage: 'Create, edit, export, and delete forms. Copy forms and use them in other projects.',
    description: 'A description of the actions available on the Jira project forms page.'
  },
  learnMoreLinkLabel: {
    id: 'proforma-project-forms.LearnMore',
    defaultMessage: 'Learn more about forms.',
    description: 'Label for a button with more information about Jira forms.'
  },
  loading: {
    id: 'proforma-project-forms.LoadingForms',
    defaultMessage: 'Loading...',
    description: 'The message for the primary loading spinner on the Jira project forms page.'
  },
  noFormsDescriptionJsm: {
    id: 'proforma-project-forms.NoFormsDescriptionJsm',
    defaultMessage: 'Add forms for customers to fill out when raising a request, or attach forms to existing issues to gather more information.',
    description: 'The description when there are no forms on the Jira project forms page in a JSM project.'
  },
  noFormsDescriptionJsw: {
    id: 'proforma-project-forms.NoFormsDescriptionJsw',
    defaultMessage: 'Add forms for customers to fill out when creating an issue, or attach forms to existing issues to gather more information.',
    description: 'The description when there are no forms on the Jira project forms page in a JSW project.'
  },
  noFormsDescriptionJwm: {
    id: 'proforma-project-forms.NoFormsDescriptionJwm',
    defaultMessage: 'Add forms for customers to fill out when creating an item, or attach forms to existing issues to gather more information.',
    description: 'The description when there are no forms on the Jira project forms page in a JWM project.'
  },
  noFormsHeading: {
    id: 'proforma-project-forms.NoFormsHeading',
    defaultMessage: 'All of your forms will show up here',
    description: 'The heading when there are no forms on the Jira project forms page.'
  },
  pageHeadingJwm: {
    id: 'proforma-project-forms.BusinessForms',
    defaultMessage: 'Advanced Forms',
    description: 'The heading of the Jira project forms (list) page for JWM projects.'
  },
  pageHeadingNonJwm: {
    id: 'proforma-project-forms.Forms',
    defaultMessage: 'Forms',
    description: 'The heading of the Jira project forms (list) page for non-JWM projects.'
  }
});